module.exports = __webpack_public_path__ + "static/56-780e28d667973f5089a79a3c8dd77a62.png";